import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ExitIcon } from "@vfit/ui/icons";
import { Background, Container, ModalContent, Padder } from "./fullScreenModal.style";
var FullScreenModal = function(props) {
    var children = props.children, show = props.show, onCloseModal = props.onCloseModal, _showIcon = props.showIcon, showIcon = _showIcon === void 0 ? true : _showIcon;
    if (!show) {
        return null;
    }
    return /*#__PURE__*/ _jsx(Background, {
        children: /*#__PURE__*/ _jsxs(Container, {
            children: [
                showIcon && /*#__PURE__*/ _jsx("div", {
                    children: /*#__PURE__*/ _jsx("span", {
                        role: "button",
                        tabIndex: 0,
                        className: "closing-icon",
                        onClick: onCloseModal,
                        onKeyDown: onCloseModal,
                        children: /*#__PURE__*/ _jsx(ExitIcon, {})
                    })
                }),
                /*#__PURE__*/ _jsx(ModalContent, {
                    className: "modalContent",
                    children: /*#__PURE__*/ _jsx(Padder, {
                        children: children
                    })
                })
            ]
        })
    });
};
export default FullScreenModal;
